import { useHistory } from "react-router-dom";
import { Box, Icon, Table, UserManual } from "../../../../../../components";
import { AFLType } from "../../../absence-letter/models";
import { useAFLColumns, useAFLRequests } from "../../../absence-letter/hooks";
import { withProcedureWraper } from "../../../..";
import CreateRequestButton from "../../../../components/CreateRequestButton";
import { Routes } from "../../../../../../AppRoutes";

const AbsenceLetterTerminateContractTSN = withProcedureWraper(() => {
  const history = useHistory();
  const { columns, columns2 } = useAFLColumns();
  const { isLoading, myRequests, myRequestsNeedApproval, completedMyRequests } = useAFLRequests({
    department: ["TSN", "KCQ"],
    aflType: AFLType.TerminationContractApplication,
  });

  const redirectToDetailPage = (requestId: string) => {
    history.push(`${Routes.absenceTerminateConstract.path}/${requestId}`);
  };

  const redirectToCreatePage = () => {
    history.push(`${Routes.createTerminationContractTSNPage.path}`);
  };

  return (
    <div className="pd15">
      <UserManual
        icon={<Icon.DocumentWrite />}
        title="ĐƠN XIN CHẤM DỨT HỢP ĐỒNG LAO ĐỘNG"
        guideLink="https://drive.google.com/file/d/1Xqoxyu9kgVxYI-MJXJUaHa7kl31fugLw/view"
      />
      <Box title="Yêu cầu đã duyệt" titleRight={<CreateRequestButton onClick={redirectToCreatePage} />}>
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={completedMyRequests}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
      <Box title="Yêu cầu cần duyệt">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={myRequestsNeedApproval}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
      <Box title="Tất cả yêu cầu">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns}
          dataSource={myRequests}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
    </div>
  );
});

export default AbsenceLetterTerminateContractTSN;
